import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  loading$ = new Subject<boolean>();

  private totalRequests = 0;
  private spinnerDelay = 500;

  startLoading() {
    this.totalRequests++;

    setTimeout(() => {
      if (this.totalRequests > 0) {
        this.loading$.next(this.anyRequests);
      }
    }, this.spinnerDelay);
  }

  stopLoading() {
    this.totalRequests--;

    if (this.totalRequests === 0) {
      this.loading$.next(this.anyRequests);
    }
  }

  private get anyRequests(): boolean {
    return this.totalRequests > 0;
  }
}
